export var FileUploadStatus;
(function (FileUploadStatus) {
    FileUploadStatus["OK"] = "ok";
    FileUploadStatus["ERROR"] = "error";
})(FileUploadStatus || (FileUploadStatus = {}));
//# sourceMappingURL=Autodiscovery.js.map